module.exports = __webpack_public_path__ + "img/news-area.627a42b.png";